import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

const categoryImages: Record<string, string> = {
  dianying: 'https://readdy.ai/api/search-image?query=Classic%20cinema%20movie%20theater%20with%20film%20reel%20and%20popcorn%2C%20warm%20vintage%20lighting%2C%20nostalgic%20atmosphere%2C%20rich%20red%20and%20gold%20decor%2C%20elegant%20composition%2C%20clean%20dark%20background&width=600&height=400&seq=cat-dianying&orientation=landscape',
  dianshiju: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20large%20flat%20screen%20TV%20displaying%20drama%20series%2C%20cozy%20evening%20atmosphere%2C%20warm%20lamp%20light%2C%20comfortable%20sofa%2C%20cinematic%20mood%2C%20clean%20composition&width=600&height=400&seq=cat-dianshiju&orientation=landscape',
  dongman: 'https://readdy.ai/api/search-image?query=Colorful%20Japanese%20style%20anime%20art%20studio%20with%20animation%20cells%20and%20drawing%20tools%2C%20vibrant%20manga%20wall%20posters%2C%20creative%20workspace%2C%20bright%20colorful%20atmosphere%2C%20clean%20composition&width=600&height=400&seq=cat-dongman&orientation=landscape',
  zongyi: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20TV%20variety%20show%20studio%20set%20with%20stage%20lights%20and%20games%2C%20energetic%20atmosphere%2C%20fun%20entertaining%20scene%2C%20vibrant%20colors%2C%20clean%20composition&width=600&height=400&seq=cat-zongyi&orientation=landscape',
  jilupian: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20camera%20equipment%20in%20wilderness%2C%20stunning%20landscape%20with%20mountains%20and%20wildlife%2C%20natural%20golden%20hour%20light%2C%20professional%20cinematography%20vibe%2C%20clean%20composition&width=600&height=400&seq=cat-jilupian&orientation=landscape',
};

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            海量影视分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            涵盖电影、电视剧、动漫、综艺、纪录片五大分类，满足你的全部观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl aspect-[3/4] cursor-pointer"
            >
              <img
                src={categoryImages[cat.slug]}
                alt={cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500/90 rounded-lg mb-2">
                  <i className={`${cat.icon} text-background-50 text-sm`}></i>
                </span>
                <h3 className="text-base font-bold text-background-50">{cat.name}</h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}